import { createCustomEnum } from "./customEnum";

const ManualWithholdTypes = createCustomEnum({
	Agent: {
		name: "agent",
		value: 1,
		displayName: "Total Agent Withhold",
	},
	Merchant: {
		name: "merchant",
		value: 2,
		displayName: "Merchant Withhold",
	},
});

export default ManualWithholdTypes;
